export default {
    "chws": {
        "menu": "Diagnostics",
        "title": "CHW Supply Temperature",
        "linkTitle": "CHW Supply Temperature",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'data2-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            }
                        },
                        'data-payload': {
                            'filters': {
                                'sensor_names': ["CHWS_Temp"],
                                "equipment_type_regex": "^chiller",
                            }
                        },
                    }
                }
            ]
    },
    "chwr": {
        "menu": "Diagnostics",
        "title": "CHW Return Temperature",
        "linkTitle": "CHW Return Temperature",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'data2-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            }
                        },
                        'data-payload': {
                            'filters': {
                                'sensor_names': ["CHWR_Temp"],
                                "equipment_type_regex": "^chiller",
                            }
                        },
                    }
                }

            ]
    },

    "chiller-performance": {
        "menu": "Diagnostics",
        "title": "Chiller Performance",
        "linkTitle": "Chiller Performance",
        "viewType": "plot-list",
        "hasEquipmentSelector":true,
        "equipmentTypeFilter":"chiller*",
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                name: "Outdoor_Temperature",
                            },
                            {
                                name: "CHWS_Temp",
                            }

                        ],
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            showlegend:true,
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Flow Rate (m3/h)"
                            }
                        },
                        'variables-list': [
                            {
                                name: "CHW_Flowrate",
                            },


                        ],
                    }
                },
                {
                    'id': 3,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            showlegend:true,
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis: {
                                title: "COP"
                            }
                        },
                        'variables-list': [
                            {
                                facility_name: "ES",
                                name: "COP",
                            },


                        ],
                    }
                }

            ]
    },
    "cooling-performance": {
        "menu": "Diagnostics",
        "title": "Cooling Performance",
        "linkTitle": "Cooling Performance",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 12,
                    'type': 'data2-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Cooling Load ",
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis:{
                                title:"Cooling Load (kWh)"
                            }
                        },
                        'series-overrides':{
                            stackgroup: 'one',
                            mode: 'none',
                        },
                        'data-payload': {
                            'filters': {
                                'sensor_names': ["Cooling_Load"],
                                "equipment_type_regex": "^chiller",
                            }
                        },
                    }
                },
                {
                    'id': 13,
                    'type': 'data2-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Power (Chiller only) ",
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            yaxis:{
                                title:"Power Consumption (kWh)"
                            }
                        },
                        'series-overrides':{
                            stackgroup: 'one',
                            mode: 'none',
                        },
                        'data-payload': {
                            'filters': {
                                'sensor_names': ["Power"],
                                "equipment_type_regex": "^chiller",
                            }
                        },
                    }
                }

            ]
    },


};
